import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonForm from "../../../components/form/form";
import useCommonFetch from "../../../../hooks/useCommonFetch";
import {
  createStock,
  getCategoryList,
  getStockDetail,
  updateStock,
} from "../../../../services/workspace/inventory.service";
import { _StockType } from "../../../../utils/common";

const AddStock = () => {
  const navigate = useNavigate();
  const [isEditValue, setIsEditValue] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subCatList, setSubCatList] = useState([]);

  const { id } = useParams();

  const items = [
    { label: "Stock", path: "/inventory/stock" },
    { label: id ? "Edit Stock" : "Add Stock" },
  ];

  const {
    data: tableData,
    handleCreate,
    handleUpdate,
  } = useCommonFetch(getCategoryList, {
    dataPath: "category.data",
    totalPath: "category.meta.total",
    errorMessage: "Failed to fetch category data!",
    debounceDelay: 500,
    customParams: {
      only_parent: true,
      with: "subCategory",
    },
  });

  useEffect(() => {
    if (tableData && Array.isArray(tableData)) {
      setCategories(tableData);
    }
  }, [tableData]);

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    const selectedCat = tableData.find((cat) => cat.id === value.value);
    const subCat =
      selectedCat?.subCategory?.map((sub) => ({
        label: sub.name,
        value: sub.id,
      })) || [];
    setSubCatList(subCat);
  };

  // Load details in edit mode
  useEffect(() => {
    if (id) {
      const fetchDetail = async () => {
        try {
          const res = await getStockDetail(id);

          if (res?.stock) {
            const stock = res.stock;

            const InitialData = {
              name: stock?.name,
              parentCategory: stock?.category?.parentCategory?.id,// its a category
              category: stock.category.id,  // its a subcate
              stock_type: stock.stock_type.toString(),
              tags: stock?.tags || "",
              description: stock?.description || "",
              is_assignable: stock.is_assignable ? 1 : 0,
            };

            
            setIsEditValue(InitialData);

            if (stock.category?.parentCategory?.id) {
              handleCategoryChange({
                value: stock.category.parentCategory.id,
                label: stock.category.parentCategory.name,
              });
            }
          }
        } catch (error) {
          console.error("Failed to fetch stock detail", error);
        }
      };
      fetchDetail();
    }
  }, [id]);

  useEffect(() => {
    if (categories && Array.isArray(categories)) {
      if(isEditValue ){

         const selectedCat = tableData.find((cat) => cat.id === isEditValue.parentCategory);
    const subCat =
      selectedCat?.subCategory?.map((sub) => ({
        label: sub.name,
        value: sub.id,
      })) || [];
    setSubCatList(subCat);
      }
    }
  }, [tableData, isEditValue]);

  // Form fields
  const categoryFields = [
    {
      name: "name",
      label: "Name",
      type: "text",
      placeholder: "Enter stock name",
      required: true,
      colSpan: 3,
    },
    {
      name: "parentCategory",
      label: "Category",
      type: "select",
      placeholder: "Select category",
      required: true,
      options: categories.map((cat) => ({
        label: cat.name,
        value: cat.id,
      })),
      onChange: handleCategoryChange,
      colSpan: 3,
    },
    {
      name: "category",
      label: "Sub Category",
      type: "select",
      placeholder: "Select sub category",
      options: subCatList,
      disabled: !selectedCategory,
      colSpan: 3,
      required: true,
    },
    {
      name: "stock_type",
      label: "Stock Type",
      type: "select",
      required: true,
      options: _StockType,
      colSpan: 3,
    },
    {
      name: "tags",
      label: "Tags",
      type: "text",
      placeholder: "Enter tags",
      required: true,
      colSpan: 12,
    },
    {
      name: "description",
      label: "Description",
      type: "textarea",
      placeholder: "Write description here...",
      colSpan: 12,
    },
     {
      name: "is_assignable",
      label: "Is this stock assignable?",
      type: "checkbox",
      placeholder: "Is this stock assignable?",
      colSpan: 12,
    },
  ];

  const handleSubmit = async (
    values,
    { setSubmitting, resetForm, setErrors }
  ) => {
    try {
      const payload = {
        name: values.name,
        parentCategory: values.parentCategory,
        category_id: values.category,
        stock_type: values.stock_type,
        tags: values.tags,
        description: values.description,
        is_assignable: values.is_assignable ? 1 : 0
      };

      if (id) {
        const res = await handleUpdate(payload, id, updateStock);
        if (res?.success) {
          resetForm();
          navigate("/inventory/stock", { replace: true });
        }
      } else {
        const res = await handleCreate(payload, createStock);
        if (res?.success) {
          resetForm();
          navigate("/inventory/stock", { replace: true });
        }
      }
    } catch (err) {
      if (err?.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
      if (err?.response?.data?.message) {
        setErrors({ name: err.response.data.message });
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate("/inventory/stock");
  };

  return (
    <div className="w-full flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />

      <div className="bg-white p-4 rounded-md">
        <CommonForm
          fields={categoryFields}
          initialData={isEditValue || {}}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          submitButtonText={id ? "Update" : "Submit"}
          onCancel={handleCancel}
          cancelButtonText="Reset"
          columnsPerRow={1}
          gap="gap-4"
          rowClassName=""
          fieldClassName="bg-white p-3 rounded shadow-sm"
          disabled={id && !isEditValue} // prevent empty form flash
        />
      </div>
    </div>
  );
};

export default AddStock;
